import { Dayjs } from 'dayjs';

// A row of the document listings.
//
// `GET /api/archives/documents` returns `issuer` but NOT `archiver`;
// `GET /api/archives/:id/my-documents` returns both. The XD "Archiveur"
// column and the edit/delete permission depend on `archiver`,
// so it is declared optional and the screen behaves according to whether it is present or not.
//
// `image_url` and `thumbnail_url` are for the Résultats grid (see
// pages/Search/DocumentGrid). Today no listing returns them: `image_url`
// only arrives in `GET /archives/document?id=` and in the creation response,
// and `thumbnail_url` does not exist yet (M1 in ROADMAP.md). They are declared
// optional so that the grid uses them the day they arrive.
export type HomeDocument = {
  id: string;
  title: string;
  issuing_date: string;
  archiving_date: string;
  service: string;
  issuer: string;
  archiver?: string;
  confidential: boolean;
  verification_url: string;
  image_url?: string | null;
  thumbnail_url?: string | null;
};

export type DocumentsPage = {
  documents: HomeDocument[];
  totalItems: number;
};

// The filters of the XD row ("2. Home" in DESIGN.md).
//
// Empty `archiver` = all. The backend does not filter `/documents` by archiver;
// a specific archiver is queried via `/:id/my-documents`, which is the only thing
// the API offers (see useDocuments).
//
// Dates: the XD draws a single range picker per column ("1 févr. 2026 - 31 mars
// 2026"), which is what the listing API now filters by (`searchDateFrom`/`To`,
// `searchArchivingDateFrom`/`To` — either bound optional on its own). Used to be
// a single exact day per column before the API grew range support.
export type DocumentFilters = {
  search: string;
  archiver: string;
  service: string;
  issuingDateFrom: Dayjs | null;
  issuingDateTo: Dayjs | null;
  archivingDateFrom: Dayjs | null;
  archivingDateTo: Dayjs | null;
};

export const EMPTY_FILTERS: DocumentFilters = {
  search: '',
  archiver: '',
  service: '',
  issuingDateFrom: null,
  issuingDateTo: null,
  archivingDateFrom: null,
  archivingDateTo: null,
};

export type FilterOption = {
  value: string;
  label: string;
};
